module.exports = __webpack_public_path__ + "img/order.5f9129a1.svg";